
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-71644895\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?sourceMap!../../vue-loader/lib/selector?type=styles&index=0!./Breadcrumb.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Breadcrumb.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-71644895\"}!../../vue-loader/lib/selector?type=template&index=0!./Breadcrumb.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-breadcrumb/src/Breadcrumb.vue
// module id = 404
// module chunks = 40